export interface AppUpdateConfigShape {
  platform: string;
  minVersion: string;
  latestVersion: string;
  blockedVersions: string[];
  forceMessage: string;
  softMessage: string;
  storeUrl: string;
  logoutOnForce: boolean;
}

function asString(v: unknown, fallback = ""): string {
  return typeof v === "string" ? v : fallback;
}

function asStringArray(v: unknown): string[] {
  if (!Array.isArray(v)) return [];
  return v.filter((x): x is string => typeof x === "string");
}

function asBool(v: unknown): boolean {
  return v === true;
}

/**
 * Coerce an AppUpdateConfigHistory snapshot (Json) into a
 * well-typed config object for a given platform. Missing or
 * wrongly-typed fields fall back to safe defaults so a broken
 * snapshot never crashes the rollback path.
 */
export function snapshotToConfig(
  platform: string,
  snapshot: unknown
): AppUpdateConfigShape {
  const s = (snapshot ?? {}) as Record<string, unknown>;
  return {
    platform,
    minVersion: asString(s.minVersion, "1.0.0"),
    latestVersion: asString(s.latestVersion, asString(s.minVersion, "1.0.0")),
    blockedVersions: asStringArray(s.blockedVersions),
    forceMessage: asString(s.forceMessage),
    softMessage: asString(s.softMessage),
    storeUrl: asString(s.storeUrl),
    logoutOnForce: asBool(s.logoutOnForce),
  };
}
